import React, { useEffect, useRef, useState } from 'react'

const TextArea = ({
  label,
  errors,
  name,
  value,
  onChange,
  onFocus,
  onBlur,
  counter,
  maxChars,
  className = '',
}) => {

  const [limitReached, setLimitReached] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    setLimitReached(value.length >= maxChars);
    adjustTextareaHeight();
  }, [value]);

  const handleChange = (event) => {
    onChange(event);
  };

  const adjustTextareaHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
      textareaRef.current.style.maxHeight = '150px';
    }
  };

  return (
    <>
    <div className={`figma-field mb-0 ${counter ? 'pb-25' : ''} ${className}`}>
      <label>{label}</label>
      <span className="ml-10 error-msg fz-12">{errors}</span>
      <textarea
        ref={textareaRef}
        name={name}
        className={`mercately-input-ta`}
        style={{ height: 'auto', resize: 'none' }}
        value={value}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {counter && (
        <span className={`limit my-5 mr-5 w-100 ${limitReached ? 'text-danger fw-bold' : ''}`} style={{ bottom: 0 }}>{value.length}/{maxChars}</span>
      )}
    </div>
    </>
  );
}

export default TextArea
